function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { FooterNavigationStyles } from './FooterNavigationStyles';
import { prefixLink } from '../../../utils';
export default function FooterNavigation(_ref) {
  var appProps = _ref.appProps,
    navigation = _ref.navigation;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mainNavHover = _useState2[0],
    setMainNavHover = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    subNavItemHover = _useState4[0],
    setSubNavItemHover = _useState4[1];
  var frontendStyles = appProps.frontendStyles;
  var currentPath = window.location.pathname;
  function navigationItemHrefClass(item) {
    return item.children.length > 0 ? 'has_submenu' : '';
  }
  function recursivelyRenderChildren(item, navigationClass) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex-box flex-column ".concat(navigationClass === 'child-submenu' ? '' : navigationClass, " ")
    }, /*#__PURE__*/React.createElement(React.Fragment, null, item.children.map(function (child, index) {
      var childTranslation = child.translations.find(function (t) {
        return t.locale === appProps.currentLocale;
      });
      var link = prefixLink(child, appProps);
      var currentChildNavigationLink = '/' + appProps.currentLocale + childTranslation.link;
      var linkStyles = {
        width: '100%',
        fontFamily: frontendStyles.textStyles.fontFamily,
        fontSize: frontendStyles.textStyles.fontSize,
        fontWeight: frontendStyles.textStyles.fontWeight,
        letterSpacing: frontendStyles.textStyles.letterSpacing,
        lineHeight: frontendStyles.textStyles.lineHeight,
        textTransform: frontendStyles.textStyles.textTransform,
        paddingTop: frontendStyles.footerNavigation.paddingTop,
        paddingRight: "calc(4% / ".concat(frontendStyles.footerNavigation.footerColumns, ")"),
        paddingBottom: frontendStyles.footerNavigation.footerColumns,
        paddingLeft: "calc(4% / ".concat(frontendStyles.footerNavigation.footerColumns, ")"),
        color: currentPath === currentChildNavigationLink || subNavItemHover === child.id ? frontendStyles.footerNavigation.colorHover : frontendStyles.footerNavigation.color
      };
      var navWithLink = /*#__PURE__*/React.createElement("a", {
        className: 'sub-nav-item',
        onMouseEnter: function onMouseEnter() {
          setSubNavItemHover(child.id);
        },
        onMouseLeave: function onMouseLeave() {
          setSubNavItemHover(null);
        },
        style: linkStyles,
        href: link,
        rel: "nofollow noindex noreferrer",
        target: child.openNewPage ? '_blank' : '_self',
        dangerouslySetInnerHTML: {
          __html: childTranslation.title
        }
      });
      var navNoLink = /*#__PURE__*/React.createElement("div", {
        className: "pointer sub-nav-item",
        onMouseEnter: function onMouseEnter() {
          setSubNavItemHover(child.id);
        },
        onMouseLeave: function onMouseLeave() {
          setSubNavItemHover(null);
        },
        style: linkStyles,
        dangerouslySetInnerHTML: {
          __html: childTranslation.title
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex-box flex-column"
      }, !child.requiresLogin ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " ") : /*#__PURE__*/React.createElement(React.Fragment, null, appProps.currentUserEmail && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " ")), child.children.length > 0 ? recursivelyRenderChildren(child, 'child-submenu') : null);
    }))));
  }
  var renderedNavigation = navigation && navigation.items.map(function (item, index) {
    var link = prefixLink(item, appProps);
    if (link !== null) {
      var itemTranslation = item.translations.find(function (t) {
        return t.locale === appProps.currentLocale;
      });
      var currentNavigationLink = '/' + appProps.currentLocale + itemTranslation.link;
      var linkStyles = {
        fontFamily: frontendStyles.textStyles.fontFamily,
        fontSize: frontendStyles.textStyles.fontSize,
        fontWeight: frontendStyles.textStyles.fontWeight,
        letterSpacing: frontendStyles.textStyles.letterSpacing,
        lineHeight: frontendStyles.textStyles.lineHeight,
        textTransform: frontendStyles.textStyles.textTransform,
        width: frontendStyles.footerNavigation.footerColumns,
        paddingTop: frontendStyles.footerNavigation.paddingTop,
        paddingRight: "calc(2% / ".concat(frontendStyles.footerNavigation.footerColumns, ")"),
        paddingBottom: frontendStyles.footerNavigation.footerColumns,
        paddingLeft: "calc(2% / ".concat(frontendStyles.footerNavigation.footerColumns, ")"),
        color: currentPath === currentNavigationLink || mainNavHover === item.id ? frontendStyles.footerNavigation.colorHover : frontendStyles.footerNavigation.color
      };
      var navWithLink = /*#__PURE__*/React.createElement("a", {
        className: "flex-box items-center ".concat(navigationItemHrefClass(item), " ").concat(mainNavHover ? 'active' : '', " "),
        onMouseEnter: function onMouseEnter() {
          setMainNavHover(item.id);
        },
        onMouseLeave: function onMouseLeave() {
          setMainNavHover(null);
        },
        style: linkStyles,
        href: link,
        rel: "nofollow noindex noreferrer",
        target: item.openNewPage ? '_blank' : '_self',
        dangerouslySetInnerHTML: {
          __html: itemTranslation.title
        }
      });
      var navNoLink = /*#__PURE__*/React.createElement("div", {
        className: "flex-box items-center pointer ".concat(navigationItemHrefClass(item), " "),
        onMouseEnter: function onMouseEnter() {
          setMainNavHover(item.id);
        },
        onMouseLeave: function onMouseLeave() {
          setMainNavHover(null);
        },
        style: linkStyles,
        dangerouslySetInnerHTML: {
          __html: itemTranslation.title
        }
      });
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: index
      }, item.children.length >= 0 && /*#__PURE__*/React.createElement(React.Fragment, null, !item.requiresLogin ? /*#__PURE__*/React.createElement("div", {
        className: "navigation-item flex-box flex-column",
        key: index
      }, itemTranslation && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " "), recursivelyRenderChildren(item, 'submenu')) : /*#__PURE__*/React.createElement(React.Fragment, null, appProps.currentUserEmail && /*#__PURE__*/React.createElement("div", {
        className: "navigation-item flex-box flex-column",
        key: index
      }, itemTranslation && /*#__PURE__*/React.createElement(React.Fragment, null, " ", link ? navWithLink : navNoLink, " "), recursivelyRenderChildren(item, 'submenu')))));
    } else {
      return null;
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "footer-navigation flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-box flex-wrap"
  }, renderedNavigation));
}